import { createReducer, on } from '@ngrx/store';

import { HttpError } from 'ish-core/models/http-error/http-error.model';
import { setErrorOn, setLoadingOn, unsetLoadingAndErrorOn } from 'ish-core/utils/ngrx-creators';

import { QuickOrder, QuickOrderError } from '../../models/custom-quickorder/custom-quickorder.model';

import {
  addQuickOrderFlyOutItemsToBasketFail,
  addQuickOrderItemsToBasket,
  addQuickOrderItemsToBasketFail,
  addQuickOrderItemsToBasketSuccess,
  createQuickOrderFlyoutItems,
  createQuickOrderFlyoutItemsFail,
  createQuickOrderFlyoutItemsSuccess,
  createQuickOrderItems,
  createQuickOrderItemsFail,
  createQuickOrderItemsSuccess,
  createQuickOrderUploadItems,
  createQuickOrderUploadItemsFail,
  createQuickOrderUploadItemsSuccess,
  deleteQuickOrder,
  deleteQuickOrderFail,
  deleteQuickOrderItems,
  deleteQuickOrderItemsFail,
  deleteQuickOrderItemsSuccess,
  deleteQuickOrderSuccess,
  loadQuickOrder,
  loadQuickOrderFail,
  loadQuickOrderSuccess,
  resetQuickOrderState,
  updateQuickOrderItem,
  updateQuickOrderItemFail,
  updateQuickOrderItemSuccess,
} from './quick-order.actions';

export interface QuickOrderState {
  quickOrder: QuickOrder;
  loading: boolean;
  validationErrors: QuickOrderError[];
  error: HttpError;
}

const initialState: QuickOrderState = {
  quickOrder: undefined,
  loading: false,
  validationErrors: undefined,
  error: undefined,
};

export const quickOrderReducer = createReducer(
  initialState,
  setLoadingOn(
    loadQuickOrder,
    createQuickOrderItems,
    createQuickOrderFlyoutItems,
    createQuickOrderUploadItems,
    updateQuickOrderItem,
    deleteQuickOrderItems,
    addQuickOrderItemsToBasket,
    deleteQuickOrder
  ),
  unsetLoadingAndErrorOn(
    loadQuickOrderSuccess,
    createQuickOrderItemsSuccess,
    createQuickOrderFlyoutItemsSuccess,
    createQuickOrderUploadItemsSuccess,
    updateQuickOrderItemSuccess,
    deleteQuickOrderItemsSuccess,
    addQuickOrderItemsToBasketSuccess,
    deleteQuickOrderSuccess
  ),
  setErrorOn(
    loadQuickOrderFail,
    createQuickOrderItemsFail,
    createQuickOrderFlyoutItemsFail,
    createQuickOrderUploadItemsFail,
    updateQuickOrderItemFail,
    deleteQuickOrderItemsFail,
    addQuickOrderFlyOutItemsToBasketFail,
    addQuickOrderItemsToBasketFail,
    deleteQuickOrderFail
  ),
  on(
    loadQuickOrderSuccess,
    createQuickOrderItemsSuccess,
    createQuickOrderFlyoutItemsSuccess,
    createQuickOrderUploadItemsSuccess,
    updateQuickOrderItemSuccess,
    deleteQuickOrderItemsSuccess,
    (state, action): QuickOrderState => ({
      ...state,
      quickOrder: action.payload.quickOrder,
      validationErrors: action.payload.quickOrder.errors,
    })
  ),
  on(
    resetQuickOrderState,
    deleteQuickOrderSuccess,
    (state): QuickOrderState => ({
      ...state,
      quickOrder: undefined,
      loading: false,
      validationErrors: undefined,
      error: undefined,
    })
  )
);
